import "core-js/modules/es.array.push.js";
import { mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      isVisible: false,
      formattedDate: [],
      products: [],
      count: 0,
      visibleTips: true
    };
  },
  props: {
    order: Object,
    id: Number,
    activeItem: {
      type: [Number, String]
    }
  },
  methods: {
    ...mapActions({
      dateFormat: "date/dateFormat"
    }),
    ...mapMutations({
      setOrderNumber: "order/setOrderNumber"
    }),
    repeatOrder() {
      this.setOrderNumber(this.order.number);
      this.$router.push({
        path: "/rol-shop/order",
        query: {
          repeat: this.order.number
        }
      });
    }
  },
  computed: {
    checkVisible() {
      return this.activeItem === this.id;
    }
  },
  watch: {
    checkVisible(value) {
      value ? this.isVisible = true : this.isVisible = false;
    }
  },
  mounted() {
    this.dateFormat({
      dayDate: this.order.day,
      yearDate: this.order.year,
      timeDate: this.order.time
    }).then(result => {
      this.formattedDate = result;
    });
    this.order.items.forEach(element => {
      this.count += element.count;
    });
    this.products = this.order.items;
    if (this.order.freeProduct) {
      this.order.freeProduct.forEach(item => this.products.push(item));
      this.count += this.order.freeProduct.length;
    }
    if (this.activeItem === this.id) {
      this.isVisible = true;
    }
  }
};